export default __webpack_public_path__ + "static/media/gallery 3.55e372bf.png";